import { createAsyncThunk } from "@reduxjs/toolkit";
import { Layout, Layouts } from "react-grid-layout";
import { updateDashboardByIdLayoutThunk } from "./updateDashboardByIdLayoutThunk";
import { generateDefaultLayoutFromWidgetIds } from "../../utils/helpers/dashboardLayout";
import { DashboardLayoutBreakpoint } from "../../utils/types/types";
import { GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse } from "@/services/cloudchipr.api";

export const generateAndUpdateDefaultLayoutForDashboardByIdThunk =
  createAsyncThunk(
    "dashboards/generateAndUpdateDefaultLayoutForDashboardById",
    async (
      response: GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
      { dispatch },
    ) => {
      const layout = response.layout as
        | Record<DashboardLayoutBreakpoint, Layout>
        | undefined;

      const defaultLayout = generateDefaultLayoutFromWidgetIds(
        response.widgets.map((widget) => widget.id),
      );

      const newLayout = {
        lg: layout?.lg ?? defaultLayout.lg,
        md: layout?.md ?? defaultLayout.md,
        sm: layout?.sm ?? defaultLayout.sm,
      } as Layouts;

      dispatch(
        updateDashboardByIdLayoutThunk({
          dashboardId: response.id,
          newLayout,
        }),
      );
    },
  );
